import React from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import useFirestore from "../../../../config/fireBaseHook";
import { formatDate } from "../../../../utils/formatDate";

const ChangeCourseRequests = () => {
  const { data, loading, error } = useFirestore("ChangeCourseRequest");

  const columns = [
    {
      field: "sectionName",
      headerName: "Section",
      flex: 1,
    },
    {
      field: "Date_Submitted",
      headerName: "Date Submitted",
      flex: 1,
      renderCell: (params) => formatDate(params.row.Date_Submitted),
    },
    {
      field: "changeAction",
      headerName: "Change Action",
      flex: 1,
    },
    {
      field: "startDate",
      headerName: "Start Date",

      flex: 1,
    },
    {
      field: "endDate",
      headerName: "End Date",

      flex: 1,
    },
    {
      field: "modality",
      headerName: "Modality",
      flex: 1,
    },
    {
      field: "instructorType",
      headerName: "Instructor Type",
      flex: 1,
    },
    {
      field: "instructorName",
      headerName: "Instructor Name",
      flex: 1,
    },
    {
      field: "startTime",
      headerName: "Start Time",
      flex: 1,
    },
    {
      field: "endTime",
      headerName: "End Time",
      flex: 1,
    },
    {
      field: "daysOfWeek",
      headerName: "Days of Week",
      flex: 1,
    },
    {
      field: "schoolName",
      headerName: "School Name",
      flex: 1,
    },
    {
      field: "fromName",
      headerName: "From Name",
      flex: 1,
    },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  // Debug: Log the data to see what fields are available
  console.log("ChangeCourseRequests data:", data);

  // Ensure each row has an id field for DataGridPro
  const processedData = data.map((item, index) => ({
    id: item.id || index,
    ...item,
  }));

  return (
    <>
      <AppDataGrid
        rows={processedData}
        columns={columns}
        loading={loading}
        slots={{ toolbar: GridToolbarNoExport }}
        pagination
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        disableSelectionOnClick
        initialState={{
          sorting: {
            sortModel: [{ field: "Date_Submitted", sort: "desc" }],
          },
        }}
      />
    </>
  );
};

export default ChangeCourseRequests;
